module.exports = __webpack_public_path__ + "static/img/8.102b179f.png";